import styled from 'styled-components';
import {dFlex, dFlexCenter, dFlexSpaceBetween, BGImageCenter, mobileMedia} from '../../../../globalVariables/GlobalVariables';
import * as symbol from '../../../../assets/symbols/symbols/Symbols.css';
import {STICKER_COLORS} from '../lectureCard/lectureSticker/LecturerSticker.css';

export const container = styled.div`
    width: 100%;
    ${dFlex}
    background: var(--TA-color-bg-surface-default);
    border-radius: var(--radius-xs);
    border: 1px solid var(--TA-color-border-subtle);
    overflow: hidden;
    flex-shrink: 0;
    ${mobileMedia} {
        border-radius: var(--radius-xs) var(--radius-xs) 0 0;
        border: none;
        border-top: 1px solid var(--TA-color-border-subtle);
    }
`;

export const stickerCol = styled.div`
    width: 44px;
    flex-shrink: 0;
    align-self: stretch;
    background: ${STICKER_COLORS[7]};
    ${dFlexCenter}
    border-radius: ${p => p.theme.rtl ? '0 4px 4px 0' : '4px 0 0 4px'};
    & > * {
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
    }
    ${mobileMedia} {
        width: 32px;
        border-radius: ${p => p.theme.rtl ? '0 4px 0 0' : '4px 0 0 0'};
    }
`;

export const content = styled.div`
    flex: 1;
    ${dFlexSpaceBetween}
    align-items: flex-start;
    padding: var(--space-lg);
    padding-inline-start: var(--space-sm);
    min-width: 0;
`;

export const details = styled.div`
    ${dFlex}
    flex-direction: column;
    gap: var(--space-xs);
    min-width: 0;
`;

export const title = styled.div`
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    color: var(--TA-color-text-default);
    text-align: start;
`;

export const subtitle = styled.div`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-regular);
    color: var(--TA-color-text-default);
    text-align: start;
`;

export const duration = styled.div`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    color: var(--TA-color-text-subtle);
    text-align: start;
`;

export const kebab = styled.button`
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    border: none;
    padding: 0;
    background: transparent;
    cursor: pointer;
    ${dFlexCenter}
    opacity: 0.6;
    &:hover {
        opacity: 1;
    }
`;

export const dragHandle = styled.div`
    width: 24px;
    flex-shrink: 0;
    align-self: stretch;
    border-inline-start: 1px solid var(--TA-color-border-subtle);
    background: var(--TA-color-bg-base);
    ${BGImageCenter(symbol.dragPoints, '10px 16px')}
    opacity: 0.5;
    cursor: grab;
    ${mobileMedia} {
        display: none;
    }
`;
